var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-wrap"},[_c('form-text-box',{ref:"receivable",attrs:{"column":_vm.column,"dataList":_vm.receivableList,"rules":_vm.receivableRules,"formProps":_vm.formProps,"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }